<template>
  <div class="line">
    <div class="line-box clear">
      <div
        v-for="(line, index) in lineList"
        :key="index"
        class="line-item-box clear"
      >
        <div v-for="(item, index) in line" :key="index" class="line-item">
          <span class="line-anchor">线路推荐</span>
          <div class="line-head">
            <img :src="item.headImg" alt="headImg" />
          </div>
          <div class="line-cont-fluid">
            <div class="line-cont">
              <div>
                【上汽奥迪Q5 e-tron 创势新生】
              </div>
              <div class="v-line-desc text-overflow">
                {{ item.desc }}
              </div>
            </div>
            <div v-maidian="'line_' + index" class="line-btm clear">
              <div class="price">
                <!-- <del class="price-span discount">{{
              line.price
            }}</del> -->
                <span class="price-span">{{
                  discount ? item.price * 0.8 : item.price
                }}</span>
                <mt-button @click="jumpToSight(item.linkId)" size="small"
                  >立即购买</mt-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      discount: false,
      lineList: [
        [
          {
            headImg:
              "https://source.qunarzz.com/site/images/wns/20220430-shijianchen-audi-1.jpg",

            tagList: ["海鲜自助", "海岛游"],
            price: 6625,
            desc: "海南三亚+陵水5日4晚私家团｜天堂森林公园+游艇出海+分界洲岛",
            linkId:
              "https://qnee9.package.qunar.com/user/detail.jsp?abt=a&id=3231219999&",
            discountId: "3401723685",
          },
          {
            headImg:
              "https://source.qunarzz.com/site/images/wns/20220430-shijianchen-audi-02.jpg",
            tagList: ["雪山温泉", "草原"],
            price: 4875,
            desc: "海南三亚+石梅湾+兴隆热带植物园+万宁6日｜多种景点任意挑选！",
            linkId:
              "https://qnee9.package.qunar.com/user/detail.jsp?abt=a&id=4028277149&",
            discountId: "1534603695",
          },
        ],
        [
          {
            headImg:
              "https://source.qunarzz.com/site/images/wns/20220430-shijianchen-audi-03.jpg",
            tagList: ["网红打卡", "自驾游"],
            price: 8880,
            desc: "三亚悦榕庄泳池别墅2晚套餐｜私密海滩+热带花园 尽享奢华体验",
            linkId:
              "https://qnel1.package.qunar.com/user/detail.jsp?abt=a&id=904723721&",
            discountId: "4078494581",
          },
          {
            headImg:
              "https://source.qunarzz.com/site/images/wns/20220430-shijianchen-audi-04.jpg",
            tagList: ["熊猫基地", "探秘"],
            price: 2360,
            desc: "深圳鹏瑞莱佛士酒店1晚含早+鸡尾酒｜与国际金融都市香港一水之隔",
            linkId:
              "https://qnel1.package.qunar.com/user/detail.jsp?abt=a&id=3638506901&",
            discountId: "2625878855",
          },
        ],
      ],
    };
  },
  methods: {
    jumpToSight(linkId) {
      window.location.href = linkId;
    },
  },
};
</script>
<style lang='less' scoped='true'>
.line {
  &-tit {
    width: 100%;
  }
}
.rem(@name,@px) {
  @{name}: unit(@px / 37.5, rem);
}
.line {
  background-color: #000;
  position: relative;
  &-box {
    padding-left: 15px;
    padding-right: 15px;
    padding-bottom:30px;
  }
  &-item {
    overflow: hidden;
    position: relative;
    border-radius: 4px;
    width: 100%;
    margin-bottom: 6px;
    z-index: 2;
    background-color: #fff;
    display: flex;
    &-box {
      position: relative;
      .bg-line {
        background: url(https://picbed.qunarzz.com/f85c6e94de1f40c4bae5c5a5c7261be5.png)
          no-repeat;
        background-size: 100% auto;
        height: 20px;
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 7px;
      }
    }
  }
  &-desc {
    height: 32px;
    font-size: 10px;
    line-height: 16px;
    margin-bottom: 5px;
    text-align: left;
  }
  &-tag {
    padding-left: 2px;
    padding-right: 2px;
    padding-top: 3px;
    padding-bottom: 3px;
    border: 0.1em solid #ff414c;
    border-radius: 2px;
    color: #ff414c;
    font-size: 9px;
    float: left;
    margin-right: 5px;
  }
  &-cont {
    padding: 5px;
  }
  &-btm {
    padding: 7px;
    margin:10px;
    position: relative;
    bottom: 10px;
    background-color: #fef8e9;
    .price {
      &-span {
        height: 19px;
        line-height: 19px;
        text-align: left;
        font-size: 15px;
        float: left;
        color: #f3427f;
        &.discount {
          color: #aaa9a9;
        }
        position: relative;
        &:before {
          content: "￥";
          font-size: 9px;
          position: relative;
        }
        &:after {
          content: "起/人";
          font-size: 9px;
          position: relative;
        }
      }
      button {
        position: relative;
        float: right;
      }
    }
  }
  &-head {
    width:161px;
    img {
      display: block;
      height: 108px;
    }
  }
  .line-item{
    margin-bottom: 15px;
  }
  .line-cont-fluid{
    width:calc(100% - 161px);
    display: flex;
    font-size: 11px;
    height: 108px;
    flex-direction: column;
    justify-content: space-between;
    text-align: left;
    line-height: 1.6;
  }
  /deep/ .mint-button--small {
    border-radius: 0;
    background-color: #f3427f;
    border-radius: 11px;
    color: #fff;
    font-size: 11px;
    height: 21px;
    margin-left: auto;
    margin-right: auto;
  }
  .line-anchor {
    position: absolute;
    left: 0;
    top: 0;
    height: 18px;
    color: #fff;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 5px;
    padding-right: 5px;
    font-size: 10px;
    background: #f3427f;
    border-radius: 3px 0px 3px 0px;
  }
}
</style>